// extracted by mini-css-extract-plugin
export default {"title":"withdrawal_title__-0Cyo"};